import React, { useState, useEffect, useContext } from "react";
import { StoreContext } from "../store";
import * as Web3 from "web3";
import {
  RENQ_USDT_PAIR_ADDRESS,
  RENQ_USDT_STAKING_ADDRESS,
  PHX_CONTRACT_ADDRESS,
  PHX_ADDRESS,
  RENQETH_STAKING_ADDRESS,
  RENQ_ETH_PAIR_ADDRESS,
  BNB_CONTRACT_ADDRESS,
} from "../constant";
import { WalletContext } from "../context/wallet";
import {
  BUSDABI,
  RENQETH_STAKING_POOL,
  PHXABI,
  PHX_STAKING_POOL,
  USDTABI,
  STAKING_POOL,
  BNB_STAKING_POOL,
} from "../abi";
import BigNumber from "bignumber.js";
import useClipboard from "react-use-clipboard";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Grid from "@mui/material/Grid";
import Tooltip from "@mui/material/Tooltip";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import Dropdown from "react-bootstrap/Dropdown";
import FarmBoxETH from "./FarmBox1";
import FarmBoxUSDT from "./FarmBox2";

const Home = () => {
  const global = useContext(StoreContext);
  const [walletAddress] = useContext(WalletContext);
  const [link] = useState(window.location + "/stake/?ref=");

  const info = [
    { apy: 24, days: "Flexible", index: 0 },
    // { apy: 20, days: "7 days", index: 1 },
    // { apy: 25, days: "14 days", index: 2 },
    // { apy: 30, days: "30 days", index: 3 },
    // { apy: 75, days: "180 days", index: 4 },
    // { apy: 150, days: "365 days", index: 5 },
  ];

  return (
    <div className="mb-5">
      <div className="section section--pb0 section--first">
        <div className="section__article-head"></div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            margin: "20px 0px",
          }}
        >
          <button s>Claim your Renq rewards before pool time expires</button>
        </div>
      </div>

      <div className="section section--article mt-5">
        <div className="container">
          <div className="row">
            {info.map((item, index) => (
              <FarmBoxETH
                item={item}
                index={item.index}
                key={index}
                walletAddress={walletAddress}
              />
            ))}
            {info.map((item, index) => (
              <FarmBoxUSDT
                item={item}
                index={item.index}
                key={index}
                walletAddress={walletAddress}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
